import { LocalTrainIcon32 } from '@repo/ui/icons'
import { useZugnummerStore } from '@/store/useZugnummerStore'
import { useShallow } from 'zustand/react/shallow'
import { cn } from '@/utils/classnames'

export interface ZugnummerDisplayProps {
  className?: string
  classNameSpan?: string
  'data-testid': string
}

export default function ZugnummerDisplay({
  className = '',
  classNameSpan = '',
  'data-testid': testId
}: Readonly<ZugnummerDisplayProps>) {
  const zugnummer = useZugnummerStore(useShallow((state) => state.zugnummer))

  if (!zugnummer) return null

  return (
    <div
      className={cn(
        className,
        'flex items-center shrink-0 gap-0.25 whitespace-nowrap'
      )}
      data-testid={testId}
    >
      <LocalTrainIcon32 data-testid={`${testId}-icon`} />
      <span
        className={cn('text-xl font-bold shrink-0 flex-nowrap', classNameSpan)}
        data-testid={`${testId}-text`}
      >
        {zugnummer}
      </span>
    </div>
  )
}
